const waitForElement = (selector, timeout = 5000) => {
  return new Promise((resolve, reject) => {
    const el = document.querySelector(selector);
    if (el) return resolve(el);

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        resolve(el);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    setTimeout(() => {
      observer.disconnect();
      reject(`DEBUG-Kiwi Sizing Chart: Element ${selector} not found`);
    }, timeout);
  });
};

const cleanKiwiInputs = (root = document) => {
  root
    .querySelectorAll('input[name^="accordionset-"]')
    .forEach((el) => el.removeAttribute('name'));
};

(async () => {
  try {
    const kiwiContainer = await waitForElement(
      '.ks-chart-container.sizing-chart-container.ks-container-with-modal',
    );
    cleanKiwiInputs(kiwiContainer);
    const observer = new MutationObserver(() => {
      cleanKiwiInputs(kiwiContainer);
    });

    observer.observe(kiwiContainer, {
      childList: true,
      subtree: true,
    });
  } catch (e) {
    console.warn('DEBUG-Kiwi Sizing Chart: ', e);
  }
})();
